const PROBLEMS = [
  {
    icon: 'ri-file-excel-2-line',
    title: 'エクセルのガント管理が限界',
    description: '更新漏れ、ファイルの重複、担当者ごとの入力差によって、最新の予定が分からない。',
  },
  {
    icon: 'ri-file-list-3-line',
    title: '日報が集まらない',
    description: '報告形式がバラバラで、管理者が内容を読み、進捗表へ転記している。',
  },
  {
    icon: 'ri-folder-open-line',
    title: '資料がバラバラ',
    description: '企画書、議事録、チャット、仕様書が複数の場所に分散し、必要な情報が見つからない。',
  },
  {
    icon: 'ri-global-line',
    title: '海外拠点と祝日がズレる',
    description: '日本と海外で稼働日が異なり、スケジュール調整や納期計算に手間がかかる。',
  },
];

export default function ProblemSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-12">
          プロジェクト管理に、こんな限界を感じていませんか？
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {PROBLEMS.map((item) => (
            <div key={item.title} className="bg-background-100 rounded-lg p-6 border border-background-200/70">
              <div className="w-10 h-10 bg-accent-100 rounded-lg flex items-center justify-center mb-4">
                <i className={`${item.icon} text-accent-600 text-lg`}></i>
              </div>
              <h3 className="text-base font-bold text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}